import { CButton, CCol, CContainer, CFormInput, CFormTextarea, CRow } from "@coreui/react";
import { Language } from "../../language/English";
import { RegionValidation } from "../../services/Region/RegionValidation";
import { RegionPojo } from "../../services/Region/RegionPojo/RegionPojo";
import { yupResolver } from "@hookform/resolvers/yup";
import { SubmitHandler, useForm } from "react-hook-form";
import { useEffect, useMemo, useState, useCallback } from "react";
import Notification from "../../services/Notification/Notification";
import RegionService from "../../services/Region/RegionService";
import Loader from "../../components/Layout/Loader";
import Logger from "../../services/Logger/Logger";
import UrlService from "../../services/Url/UrlService";

const RegionForm = (props : { regionForEdit : RegionPojo|undefined, setRegionForEdit : Function, manageRegionForState : Function }) => {
    const notification = useMemo(() => new Notification(), []);
    const [ showLoader, setShowLoader ] = useState<boolean>(false);
    const regionService = useMemo(() => new RegionService(), []);
    const formValidation = RegionValidation();
    const [ region, setRegion ] = useState<RegionPojo>();
    const {register, handleSubmit, setValue, formState : {errors}} = useForm<RegionPojo>({
        resolver : yupResolver(formValidation)
    });
    const urlService = useMemo(() => new UrlService(), []);
    const [existingUrl, setExistingUrl] = useState('');
    const logger = useMemo(() => new Logger(), []);
    const [ url, setUrl] = useState<string>();
    const [ showUrlExist, setShowUrlExist ] = useState<boolean>(false);

    
    useEffect(() => {
        if(region?.url)
        {
            setExistingUrl(region?.url);
        }
    }, [region])

    const doesUrlExist = useCallback(async (url: string) :Promise<void> => {
        try {
            if(url)
            {
                setShowUrlExist(false);
                if(existingUrl != url)
                {
                    if(url !== undefined && url !== ''){
                        const result = await urlService.doseUrlExist(url);
                        if(result.isSuccess === true){
                            if(result?.doesUrlExist)
                            {
                                setShowUrlExist(true);
                            }
                        }
                    }
                }
            }
            
            
        } catch (e){
            notification.error(Language.SOMETHING_IS_WRONG);
            setShowLoader(false);
            logger.error(e);
        }
    }, [logger, notification, url, urlService]);

    const handleInputChange = (url : string) => { 
        setUrl(url);
        if(existingUrl != url)
        {
            doesUrlExist(url);
        }
      };

    useEffect(() => {
        setRegion(props.regionForEdit);
        if(props.regionForEdit !== undefined){
            window.scrollTo(0, 0);
        }
    }, [props.regionForEdit])

    useEffect(() => {
        setValue('name', region?.name || '');
        setValue('url', region?.url || '');
        setValue('description', region?.description || '');
        setValue('title1', region?.title1 || '');
        setValue('title2', region?.title2 || '');
        setValue('metaKeyword', region?.metaKeyword || '');
        setValue('metaTitle', region?.metaTitle || '');
        setValue('metaDescription', region?.metaDescription || '');
    }, [region]);

    const reloadPage = () => {
        window.location.reload();
      };
    const onSubmit: SubmitHandler<RegionPojo> = async(data) => {
        if(data.url === '' ) {
            notification.error(Language.URL_IS_REQUIRED);
            return;
        }
        
        setShowLoader(true);
        if(region)
        {
            data.regionId = region?.regionId;
        }

        if(region === undefined)
        {
            const response = await regionService.create(data);
            setShowLoader(false);
            if(response.isSuccess){
                props.setRegionForEdit(undefined);
                notification.success(Language.SUCCESSFULLY_CREATED_REGION);
                setTimeout(reloadPage, 3000);
            } else {
                if(response.message !== null){
                    notification.error(response.message);
                } else {
                    notification.error(Language.SOME_TECHNICAL_ERROR_PLEASE_CALL_BACKEND_TEAM);
                }
            }
        }
        else
        {
            const response = await regionService.update(data);
            setShowLoader(false);
            if(response.isSuccess){
                props.setRegionForEdit(undefined);
                props.manageRegionForState(response.region);
                notification.success(Language.SUCCESSFULLY_UPDATED_REGION);
                setTimeout(reloadPage, 3000);
            } else {
                if(response.message !== null){
                    notification.error(response.message);
                } else {
                    notification.error(Language.SOME_TECHNICAL_ERROR_PLEASE_CALL_BACKEND_TEAM);
                }
            }
        }
    }

    return(
        <CContainer className="mt-4">
            {
                showLoader ? <Loader /> : null
            }
            <CRow>
                <CCol md={12}>
                    <h3>  
                        { Language.MANAGE_REGION } 
                        { 
                            region !== undefined ? <span className="sub-heading-service-meta-data"> for {region.name}</span> : null
                        }
                    </h3>
                </CCol>
                <CCol md={3} > <hr className="custom_hr"/> </CCol>
                <CCol md={9}></CCol>
                <CCol md={6} className="mb-3 mb-md-0"> 
                    <CFormInput label={Language.NAME} {...register('name')} placeholder={Language.TYPE_HERE} aria-describedby="Url" readOnly={false} disabled={false}/>
                </CCol>
                <CCol md={6} className="mb-3 mb-md-0"> 
                    <CFormTextarea onKeyPress={(e) => { if (new RegExp(/[a-zA-Z0-9-]/).test(e.key)) { } else e.preventDefault(); }} {...register('url')}  rows={1} id="url" label={Language.URL} onBlur={ (e) => handleInputChange(e.target.value) } placeholder={Language.TYPE_HERE} text={Language.MUST_3_200_CHAR_LONG} aria-describedby="url" />
                    { errors.url && <div className="alert alert-danger">{errors.url.message}</div> }
                    { showUrlExist ? <div className="alert alert-danger">{Language.URL_ALREADY_EXIST}</div> : null }
                </CCol>
                <CCol md={12} className=""> <hr></hr> </CCol>
                <CCol md={12} className="mb-3 mb-md-0"> 
                    <CFormTextarea rows={3} {...register('description')} label={Language.DESCRIPTION} placeholder={Language.TYPE_HERE} text={Language.MAX_1000_CHARACTERS} aria-describedby="description" />
                    { errors.description && <div className="alert alert-danger">{errors.description.message}</div> }
                </CCol>
                <CCol md={6} className="mb-3 mb-md-0"> 
                    <CFormInput {...register('title1')}  id="title1" label={Language.SEARCH_META_DATA_TOP_TITLE} placeholder={Language.TYPE_HERE} text={Language.MUST_10_250_CHAR_LONG} aria-describedby="title1" />
                    { errors.title1 && <div className="alert alert-danger">{errors.title1.message}</div> }
                </CCol>

                <CCol md={6} className="mb-3 mb-md-0"> 
                    <CFormInput {...register('title2')}  id="title2" label={Language.SEARCH_META_DATA_BOTTOM_TITLE} placeholder={Language.TYPE_HERE} text={Language.MUST_10_250_CHAR_LONG} aria-describedby="title2" />
                    { errors.title2 && <div className="alert alert-danger">{errors.title2.message}</div> }
                </CCol>

                <CCol md={12} className=""> <hr></hr> </CCol>

                <CCol md={6} className="mb-3 mb-md-0"> 
                    <CFormTextarea {...register('metaTitle')}  rows={3} id="metaTitle" label={Language.SEARCH_META_DATA_META_TITLE} placeholder={Language.TYPE_HERE} text={Language.MUST_10_250_CHAR_LONG} aria-describedby="metaTitle" />
                </CCol>

                <CCol md={6} className="mb-3 mb-md-0"> 
                    <CFormTextarea {...register('metaKeyword')} rows={3} id="metaKeyword" label={Language.META_KEYWORD} placeholder={Language.TYPE_HERE} text={Language.MUST_10_250_CHAR_LONG} aria-describedby="metaKeyword" />
                </CCol>
                <CCol md={12} className=""> <hr></hr> </CCol>

                <CCol md={6} className=""> 
                    <CFormTextarea {...register('metaDescription')} rows={3} id="metaDescription" label={Language.META_DESCRIPTION} placeholder={Language.TYPE_HERE} text={Language.MUST_10_900_CHAR_LONG} aria-describedby="metaDescription" />
                </CCol>
                <CCol md={12} className=""> <hr></hr> </CCol>
                <CCol md={12} className=""> 
                    {
                        region === undefined ? (
                            <div>
                            <CButton type="submit" onClick={handleSubmit(onSubmit)} className="save-search-meta-data-button">
                                { Language.SAVE_REGION }
                            </CButton>
                            </div>
                        ) : (
                                region !== undefined ?
                                <div className="update-button-container">
                                    <CButton className="btn-dark cancel_button" onClick={(e) => props.setRegionForEdit(undefined)}>{Language.CANCEL}</CButton>
                                    <CButton className="btn-warning update_button" onClick={handleSubmit(onSubmit)}>{Language.UPDATE_REGION}</CButton>
                                </div> : null
                        )
                    }
                </CCol>
                <CCol md={12} className=""> <hr></hr> </CCol>

            </CRow>
        </CContainer>
    );
}
export default RegionForm;